export type CaseOutcomeResult = 'routine' | 'complicated' | 'adverse'

export type CaseOutcomeStatus = 'pending' | 'completed'

export type CaseOutcomeNamedRef = {
  id: string
  name: string
}

export type CaseOutcomeRecord = {
  id: string
  case_id: string
  status: CaseOutcomeStatus
  result: CaseOutcomeResult | null
  notes: string | null
  completed_at: string | null
  updated_by: string | null
  further_complications: CaseOutcomeNamedRef[]
  reminder_sent_at?: string | null
  created_at?: string | null
  updated_at?: string | null
}

export type CaseOutcomePayload = {
  case_id: string
  status: CaseOutcomeStatus
  result: CaseOutcomeResult | null
  notes: string | null
  further_complications: CaseOutcomeNamedRef[]
  completed_at: string | null
  updated_by: string | null
  reminder_days: number
  due_at: string | null
  is_due: boolean
  outcome: CaseOutcomeRecord | null
}

export type CaseOutcomeUpdatePayload = {
  result: CaseOutcomeResult
  notes?: string | null
  further_complication_ids?: string[]
}

export const CASE_OUTCOME_RESULT_LABELS: Record<CaseOutcomeResult, string> = {
  routine: 'Routine',
  complicated: 'Complicated',
  adverse: 'Adverse',
}

export const CASE_OUTCOME_RESULTS: CaseOutcomeResult[] = [
  'routine',
  'complicated',
  'adverse',
]
